var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.classes},[_c('i',{class:_vm.indicatorClasses,attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.figure.replace('-', ''))+"%\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }